import { useState } from 'react';
import { Row, Col, Form, InputGroup } from 'react-bootstrap';
import { MAX_NUMBER, MIN_TPA_MONTHS, MAX_TPA_MONTHS } from '../../../../../constants/constants';
import CurrencyField from '../../../fields/CurrencyField';
import YesNoRadioFieldset from '../../../fields/YesNoRadioFieldset';
import Required from '../../../../../utils/Required';
import NumericalField from '../../../fields/NumericalField';

const CaresProgramOptions = ({
  tpaFlg,
  onTpaFlgChange,
  tpaMonths,
  onTpaMonthsChange,
  tpaMonthlyInstallmentEst,
  onTpaMonthlyInstallmentEstChange,
  weatherizationProgramInterest,
  onWeatherizationProgramInterestChange,
  isSubmitting,
}) => {

  const [touched, setTouched] = useState(false);
    
  const getTpaMonthsError = () => {
    if (!tpaMonths) return `Number of TPA Months is required.`;
    if (tpaMonths > MAX_TPA_MONTHS || tpaMonths < MIN_TPA_MONTHS) return `Number of TPA Months must be between ${MIN_TPA_MONTHS} and ${MAX_TPA_MONTHS}.`;
    return null;
  };

  const errorMessage = getTpaMonthsError();

  return (
    <>
      <Row>
        <Col>
          <YesNoRadioFieldset
            name="tpaFlg"
            legend="Is Customer Requesting a Long-Term Payment Arrangement on their past due balance?"
            value={tpaFlg}
            onChange={onTpaFlgChange}
            required
            disabled={isSubmitting}
          />
        </Col>
      </Row>

      {tpaFlg === 'Yes' && (
      <Row className="mt-3">
        <Col md={6}>
          <NumericalField
            fieldName="Number of Months"
            min={MIN_TPA_MONTHS}
            max={MAX_TPA_MONTHS}
            value={tpaMonths}
            onChange={onTpaMonthsChange}
            isSubmitting={isSubmitting}
          />
        </Col>
        <Col md={6} className="mb-3">
          <CurrencyField
            value={tpaMonthlyInstallmentEst}
            onChange={onTpaMonthlyInstallmentEstChange}
            fieldName="Monthly Installment Estimate"
            min={1}
            required
            isSubmitting={isSubmitting}
          />
        </Col>
      </Row>
      )}
      <hr />
      <Row>
        <Col>
          <YesNoRadioFieldset
            name="weatherizationProgramInterest"
            legend={
              <>Is the customer interested in hearing about our <i>free</i> weatherization program?</>
            }
            value={weatherizationProgramInterest}
            onChange={onWeatherizationProgramInterestChange}
            required
            disabled={isSubmitting}
          />
        </Col>
      </Row>
    </>
  );
};

export default CaresProgramOptions;